import { CSSObjectWithLabel, StylesConfig } from 'react-select';
import {
	selectStyles,
	selectStylesControl,
	selectStylesOption,
} from '../selectValue';
import { Option } from 'shared/types';
import { DISABLED_INPUT_COLOR } from 'shared/consts';
import { getContrastColor } from 'shared/lib/colors';

const isOption = (value: unknown): value is Option => {
	return (
		typeof value === 'object' &&
		value !== null &&
		'value' in value &&
		typeof (value as Option).value === 'string'
	);
};

export const getColourStyles = (
	isDisable: boolean = false,
	tagColor?: string,
): StylesConfig => {
	return {
		...selectStyles,
		multiValue: (styles, { data }: { data: any }) => {
			const style = {
				...styles,
				backgroundColor: '#FFFF',
				borderRadius: '24px',
			};
			if (isOption(data)) {
				if (tagColor) {
					style.border = `2px solid ${tagColor}`;
					style.background = tagColor;
          style.color = getContrastColor(tagColor);
				} else {
          const color = (data as Option & { color: string }).color
					style.border = `2px solid ${color}`;
					style.background = color;
          style.color = getContrastColor(color);
				}
			}
			return style;
		},
    multiValueLabel: (provided: CSSObjectWithLabel) => {
      return {
        ...provided,
        color: 'inherit'
      }
    },
		option: (provided: CSSObjectWithLabel, state: any) => ({
			...provided,
			...selectStylesOption(state),
		}),
		menuPortal: base => ({ ...base, zIndex: 1050 }),
		menu: base => ({
			...base,
			zIndex: 1050,
			display: 'flex',
			justifyContent: 'center',
			borderRadius: '24px',
			maxHeight: '220px'
		}),
		control: (provided, state) => ({
			...provided,
			...selectStylesControl(state),
			background: isDisable ? DISABLED_INPUT_COLOR : '#FFFFFF',
			pointerEvents: isDisable ? 'none' : 'initial',
		}),
	};
};
